export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  imageAlt: string;
  tags: string[];
  views: number;
  comments: number;
  isHot: boolean;
  isTrending: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '网红塌房', slug: 'wanghong-tafang', description: '网红翻车、塌房事件第一手爆料', icon: 'ri-user-unfollow-line', count: 128 },
  { name: '明星黑料', slug: 'mingxing-heiliao', description: '明星八卦、黑料内幕深度挖掘', icon: 'ri-star-line', count: 256 },
  { name: '每日大赛', slug: 'meiri-dasai', description: '热门吃瓜大赛实时追踪报道', icon: 'ri-fire-line', count: 89 },
  { name: '吃瓜视频', slug: 'chigua-shipin', description: '精彩吃瓜视频合集在线观看', icon: 'ri-video-line', count: 342 },
  { name: '黑料曝光', slug: 'heiliao-baoguang', description: '独家黑料曝光、内幕揭秘', icon: 'ri-spy-line', count: 173 },
  { name: '八卦杂谈', slug: 'bagua-zatan', description: '娱乐圈八卦趣闻轻松吃瓜', icon: 'ri-chat-smile-2-line', count: 415 },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某千万粉丝网红深夜直播翻车，偷税漏税细节全曝光',
    slug: 'qianwan-fensi-wanghong-toushui-loushui',
    excerpt: '一场深夜直播中，某拥有千万粉丝的知名网红突然被平台封禁，背后偷税漏税问题浮出水面，引发全网热议...',
    content: `<p>据知情人士爆料，某拥有千万粉丝的知名网红在深夜直播时突然被平台强制下播，随后账号被暂时封禁。经多方核实，该网红涉嫌偷税漏税，金额高达数千万元。</p><p>消息人士透露，税务部门早已对该网红展开调查，此次直播封禁只是冰山一角。该网红通过设立多家空壳公司、虚假申报等方式逃避税款，涉及金额巨大。</p><p>此事曝光后，立刻在各大社交平台引发轩然大波。不少网友表示"早就觉得他不靠谱"，也有人认为"网红行业确实需要整顿了"。</p><p>目前，该网红的所有社交账号均已处于禁言状态，其工作室也暂未对外发布任何声明。业内人士分析，此次事件或将成为网红行业整顿的标志性案例。</p><h2>事件时间线</h2><p>据梳理，该网红从2023年开始就频繁变更签约公司，每次变更都伴随着大量资金的转移。税务部门在例行抽查中发现异常后，展开了长达半年的调查。</p><h2>行业影响</h2><p>此次事件对整个网红行业产生了深远影响。多个平台已开始自查自纠，要求旗下主播补缴税款。业内人士预计，接下来将有更多网红被查处。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    author: '吃瓜小编',
    publishDate: '2026-07-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20studio%20scene%20with%20a%20streaming%20setup%20on%20a%20wooden%20desk%2C%20dramatic%20red%20warning%20light%20effect%2C%20dark%20atmosphere%2C%20suspenseful%20mood%2C%20editorial%20photography%20with%20cinematic%20lighting%2C%20high%20contrast%2C%20clean%20composition%2C%20warm%20and%20cool%20tone%20mix&width=800&height=500&seq=article-wanghong-01&orientation=landscape',
    imageAlt: '网红直播翻车偷税漏税曝光',
    tags: ['网红', '偷税漏税', '直播翻车', '账号封禁'],
    views: 128500,
    comments: 3421,
    isHot: true,
    isTrending: true,
  },
  {
    id: '2',
    title: '当红小生深夜密会神秘女子，酒店共度8小时被拍',
    slug: 'danghong-xiaosheng-mi-hui-shenmi-nvzi',
    excerpt: '知名狗仔队拍到某当红小生深夜与一名神秘女子先后进入某五星级酒店，两人在酒店共度8小时后分别离开...',
    content: `<p>日前，知名狗仔团队在某五星级酒店外蹲守多日，终于拍到了惊人一幕。某当红流量小生在深夜11点左右低调进入酒店，约半小时后，一名身着黑色连衣裙的神秘女子也出现在酒店大堂。</p><p>据拍摄到的画面显示，两人虽然刻意错开时间进入，但第二天早上7点左右，该女子先行离开酒店，约20分钟后，该男星也戴着口罩匆匆离开。</p><p>该男星此前一直以"单身"人设示人，粉丝群体庞大。此次事件曝光后，粉丝反应激烈，有人表示"不相信"，也有人留言"尊重私生活"。</p><h2>经纪公司回应</h2><p>事件发酵后，该男星的经纪公司发布声明称"艺人私生活不便过多干预"，未正面否认恋情传闻，更加剧了外界的猜测。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    author: '娱乐扒姐',
    publishDate: '2026-07-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20at%20night%20with%20warm%20golden%20lighting%2C%20mysterious%20atmosphere%2C%20blurred%20figures%20entering%20through%20revolving%20doors%2C%20cinematic%20mood%2C%20paparazzi%20style%20photography%2C%20dark%20tones%20with%20neon%20accents%2C%20urban%20night%20scene&width=800&height=500&seq=article-mingxing-02&orientation=landscape',
    imageAlt: '当红小生深夜密会神秘女子',
    tags: ['明星', '恋情曝光', '酒店密会', '流量小生'],
    views: 256300,
    comments: 8721,
    isHot: true,
    isTrending: true,
  },
  {
    id: '3',
    title: '2026年度最大吃瓜大赛：网红圈选秀节目黑幕大揭秘',
    slug: '2026-zuida-chigua-dasai-heimu',
    excerpt: '一场备受关注的网红选秀节目被曝存在严重黑幕，多位参赛选手集体发声，节目组内定冠军的聊天记录流出...',
    content: `<p>2026年备受瞩目的网红选秀节目《星光制造》近期陷入巨大争议。多位参赛选手集体发声，指控节目组存在严重的黑幕操作，包括内定冠军、恶意剪辑、强制签约等。</p><p>据曝光的聊天记录显示，节目组工作人员在内部群聊中明确提到了"保送选手"的安排，甚至连最终名次都提前确定。这些聊天记录的流出，让节目公信力瞬间崩塌。</p><h2>选手集体维权</h2><p>目前已有超过20名参赛选手联合发声，要求节目组公开道歉并退还参赛费用。其中一位人气选手在社交媒体发文："我们付出了真心和努力，换来的却是早已写好的剧本。"</p><h2>节目组回应</h2><p>节目组发表声明称聊天记录系"伪造"，并表示将通过法律途径追究责任。但这一回应并未平息舆论，反而引发了更大的质疑声浪。</p>`,
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '吃瓜前线',
    publishDate: '2026-07-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20empty%20judges%20table%20with%20papers%20scattered%2C%20behind%20the%20scenes%20chaos%20atmosphere%2C%20reality%20show%20setting%2C%20moody%20cinematic%20lighting%2C%20warm%20spotlight%20on%20empty%20stage%2C%20editorial%20documentary%20style&width=800&height=500&seq=article-dasai-03&orientation=landscape',
    imageAlt: '网红选秀节目黑幕大揭秘',
    tags: ['选秀', '黑幕', '网红', '维权'],
    views: 189200,
    comments: 5623,
    isHot: true,
    isTrending: true,
  },
  {
    id: '4',
    title: '吃瓜视频：某知名主播带货翻车现场，产品质量堪忧',
    slug: 'zhuming-zhubo-daihuo-fanche',
    excerpt: '一段某知名带货主播直播翻车视频在网上疯传，其推荐的产品被当场检测出质量问题，场面一度十分尴尬...',
    content: `<p>近日，一段某知名带货主播的直播翻车视频在各大平台疯传。视频中，该主播正在热情推荐一款护肤品，声称"自己每天都在用"，然而直播间的一位观众当场拿出检测报告，指出该产品存在成分造假问题。</p><p>视频显示，该主播在看到检测报告后表情瞬间凝固，试图转移话题但被直播间观众刷屏追问。最终，该主播以"需要核实"为由匆匆下播。</p><p>该视频在一天之内播放量突破500万，弹幕和评论区充满了"翻车现场"、"尴尬到脚趾扣地"等评论。</p>`,
    category: '吃瓜视频',
    categorySlug: 'chigua-shipin',
    author: '视频搬运工',
    publishDate: '2026-07-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20setup%20with%20ring%20light%20and%20products%20on%20desk%2C%20embarrassed%20expression%20mood%2C%20dramatic%20moment%2C%20warm%20studio%20lighting%20turning%20cold%2C%20ecommerce%20livestream%20scene%2C%20product%20review%20gone%20wrong%2C%20editorial%20style%20with%20high%20detail&width=800&height=500&seq=article-shipin-04&orientation=landscape',
    imageAlt: '知名主播带货翻车现场',
    tags: ['带货翻车', '直播', '产品质量', '吃瓜视频'],
    views: 523600,
    comments: 12450,
    isHot: false,
    isTrending: true,
  },
  {
    id: '5',
    title: '独家曝光：某顶流女星背后的资本运作与合约纠纷',
    slug: 'dingliu-nvxing-ziben-yunzuo-hetong-jiufen',
    excerpt: '深度调查揭秘某顶流女星与其经纪公司之间的复杂资本关系，涉及对赌协议、股权纠纷等内幕信息...',
    content: `<p>经过长达三个月的深度调查，我们独家获取了某顶流女星与其背后经纪公司的复杂资本运作内幕。据悉，该女星与公司签订了一份价值数亿的对赌协议，但在协议即将到期时出现严重分歧。</p><p>据接近该女星的人士透露，经纪公司在协议期间存在多项违约行为，包括擅自接洽商业合作、隐瞒真实收入等。而经纪公司方面则指责该女星"耍大牌"，拒绝履行合约义务。</p><p>双方的矛盾在最近一次董事会后彻底激化，目前已经进入法律程序。若对赌失败，该女星可能面临巨额赔偿。</p>`,
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    author: '深度调查组',
    publishDate: '2026-07-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20stacked%20legal%20documents%20and%20contracts%20on%20dark%20wooden%20table%2C%20dramatic%20shadows%20from%20window%20blinds%2C%20serious%20business%20atmosphere%2C%20financial%20documents%20scattered%2C%20investigative%20journalism%20mood%2C%20warm%20amber%20lighting%2C%20high%20contrast&width=800&height=500&seq=article-heiliao-05&orientation=landscape',
    imageAlt: '顶流女星资本运作合约纠纷',
    tags: ['女星', '资本运作', '对赌协议', '合约纠纷'],
    views: 312800,
    comments: 7890,
    isHot: true,
    isTrending: false,
  },
  {
    id: '6',
    title: '娱乐圈最新八卦：三对明星夫妻婚姻状况大起底',
    slug: 'yulequan-san-dui-fuqi-hunyin-zhuangkuang',
    excerpt: '近期娱乐圈多对明星夫妻被传婚变，有知情人士爆料了其中三对夫妻的真实婚姻状况，信息量巨大...',
    content: `<p>娱乐圈的婚姻向来是吃瓜群众最关心的话题之一。近期，多位知情人士向我们透露了三对明星夫妻的真实婚姻状况，信息量之大令人咋舌。</p><p>第一对夫妻虽然表面上恩爱如初，但实际上已经分居近一年，只是为了商业代言合约才维持表面关系。第二对夫妻则已经秘密协议离婚，但因为孩子抚养权问题一直未公开。第三对的情况较为复杂——一方出轨被另一方发现，目前正处于"冷静期"。</p><p>这三对夫妻在公众面前都维持着"模范夫妻"的形象，甚至在社交媒体上还经常互动秀恩爱，与真实情况形成鲜明对比。</p>`,
    category: '八卦杂谈',
    categorySlug: 'bagua-zatan',
    author: '八卦小能手',
    publishDate: '2026-07-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20elegant%20wedding%20rings%20on%20a%20dark%20velvet%20surface%2C%20soft%20dramatic%20lighting%2C%20one%20ring%20slightly%20separated%20from%20others%2C%20mysterious%20and%20emotional%20atmosphere%2C%20luxury%20jewelry%20photography%2C%20warm%20and%20cool%20tone%20blend%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-bagua-06&orientation=landscape',
    imageAlt: '明星夫妻婚姻状况大起底',
    tags: ['明星夫妻', '婚变', '八卦', '娱乐圈'],
    views: 445100,
    comments: 10234,
    isHot: false,
    isTrending: true,
  },
  {
    id: '7',
    title: '某头部MCN机构被曝压榨主播，不平等条约细节流出',
    slug: 'toubu-mcn-yazha-zhubo-bupingdeng-tiaoyue',
    excerpt: '一份疑似某头部MCN机构的内部合同被曝光，其中包含大量对主播极为不利的条款，引发行业广泛讨论...',
    content: `<p>一份疑似某头部MCN机构的内部主播签约合同近日在网络上广泛流传。合同中包含多项令人震惊的不平等条款，包括主播收入的80%归机构所有、主播离职后三年内不得从事相关行业等。</p><p>该合同的曝光引发了行业内外对MCN机构管理的广泛讨论。多位已离职的前主播纷纷现身说法，证实了合同中提到的苛刻条件确实存在。</p><p>有法律专家指出，合同中部分条款可能涉嫌违反劳动法，如果主播提起诉讼，胜诉的可能性很大。</p>`,
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    author: '行业观察员',
    publishDate: '2026-07-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20legal%20contracts%20with%20red%20stamps%20and%20highlighted%20clauses%20on%20a%20minimal%20white%20desk%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20corporate%20whistleblower%20atmosphere%2C%20warm%20amber%20and%20cool%20shadow%20contrast%2C%20investigative%20journalism%20style&width=800&height=500&seq=article-mcn-07&orientation=landscape',
    imageAlt: '头部MCN机构压榨主播合同曝光',
    tags: ['MCN', '主播', '合同纠纷', '行业黑幕'],
    views: 167400,
    comments: 4521,
    isHot: false,
    isTrending: false,
  },
  {
    id: '8',
    title: '吃瓜视频合集：本月最尴尬的五个明星采访名场面',
    slug: 'benyue-zui-ganga-mingxing-caifang',
    excerpt: '盘点本月明星采访中最尴尬的五个名场面，从答非所问到当场黑脸，每一个都让人隔着屏幕感到尴尬...',
    content: `<p>明星采访是吃瓜群众最爱的内容之一，而当采访出现意外时，往往会诞生经典名场面。本期吃瓜视频合集，我们盘点了本月最尴尬的五个明星采访片段。</p><p>排名第一的是某流量小生在被问及学历问题时支支吾吾答非所问的名场面；第二名是某女星被问及整容传闻时当场黑脸的尴尬瞬间；第三名则是一位老牌歌手被主持人认错名字后幽默回怼，虽然尴尬但展现了高情商。</p><p>这些视频片段在各大平台的累计播放量已突破千万，成为本月最热门的吃瓜内容之一。</p>`,
    category: '吃瓜视频',
    categorySlug: 'chigua-shipin',
    author: '视频君',
    publishDate: '2026-06-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20interview%20set%20with%20bright%20studio%20lights%20and%20microphones%2C%20awkward%20moment%20captured%2C%20talk%20show%20atmosphere%2C%20warm%20lighting%2C%20entertainment%20news%20photography%2C%20celebrity%20interview%20scene%20with%20dramatic%20expression%2C%20vibrant%20colors&width=800&height=500&seq=article-shipin-08&orientation=landscape',
    imageAlt: '本月最尴尬明星采访名场面',
    tags: ['明星采访', '尴尬名场面', '吃瓜视频', '盘点'],
    views: 298700,
    comments: 6789,
    isHot: false,
    isTrending: true,
  },
  {
    id: '9',
    title: '百万粉丝美食博主被曝食材造假，团队内部聊天记录流出',
    slug: 'meishi-bozhu-shicai-zaojia',
    excerpt: '一位拥有数百万粉丝的美食博主被前员工爆料其视频中使用的"高级食材"实为廉价替代品...',
    content: `<p>一位以"高端美食探店"为卖点的百万粉丝美食博主近日遭遇信任危机。其前团队成员匿名爆料称，该博主视频中出现的所谓"顶级和牛"、"进口海鲜"等高级食材，实际使用的是廉价替代品。</p><p>据流出的团队内部聊天记录显示，该博主曾明确指示采购人员"买最便宜的，反正拍出来看不出来"。更令人震惊的是，该博主推荐的多家"宝藏餐厅"实际上是付费推广，与其视频中声称的"真实探店"完全不符。</p><p>事件曝光后，该博主的粉丝数在一天之内减少了近20万，多个品牌方也宣布终止合作。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    author: '打假小分队',
    publishDate: '2026-06-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20photography%20set%20with%20beautifully%20plated%20dishes%20alongside%20raw%20ingredients%20in%20contrast%2C%20split%20lighting%20showing%20glamorous%20vs%20reality%2C%20food%20styling%20behind%20the%20scenes%2C%20dramatic%20reveal%20concept%2C%20warm%20and%20cool%20lighting%20contrast&width=800&height=500&seq=article-meishi-09&orientation=landscape',
    imageAlt: '美食博主食材造假曝光',
    tags: ['美食博主', '食材造假', '探店', '信任危机'],
    views: 198300,
    comments: 5432,
    isHot: false,
    isTrending: false,
  },
  {
    id: '10',
    title: '某知名导演潜规则女演员录音曝光，多位女星集体发声',
    slug: 'zhuming-daoyan-qian-guize-luyin',
    excerpt: '一段疑似某知名导演与女演员的私下通话录音在网上曝光，录音内容令人震惊，多位女星随后集体发声...',
    content: `<p>一段疑似某知名导演与年轻女演员的私下通话录音近日在网络上引起轩然大波。录音中，该导演以"给角色"为条件，对女演员提出了不当要求，言语露骨令人不适。</p><p>录音曝光后，多位女星在社交媒体上集体发声，虽然没有直接点名，但内容明显指向该导演。一位已隐退的资深女演员更是发文称："这个行业的某些人，终于要被曝光了。"</p><p>目前，该导演的所有新项目均已暂停，多个行业协会也表示将介入调查。业内人士认为，此次事件可能引发娱乐圈新一轮的"#MeToo"运动。</p>`,
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    author: '正义小编',
    publishDate: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20empty%20on%20a%20dark%20movie%20set%2C%20dramatic%20spotlight%20casting%20long%20shadow%2C%20clapperboard%20in%20foreground%2C%20moody%20cinematic%20atmosphere%2C%20suspenseful%20tension%2C%20warm%20and%20dark%20contrast%20lighting%2C%20film%20industry%20theme&width=800&height=500&seq=article-daoyan-10&orientation=landscape',
    imageAlt: '知名导演潜规则录音曝光',
    tags: ['导演', '潜规则', '女演员', '录音曝光'],
    views: 567800,
    comments: 15678,
    isHot: true,
    isTrending: true,
  },
  {
    id: '11',
    title: '网红圈大地震：某平台TOP10主播集体被约谈',
    slug: 'wanghongquan-dadizhen-pingtai-yuetan',
    excerpt: '据可靠消息，某短视频平台排名前十的主播近日集体被有关部门约谈，涉及内容违规、税务等问题...',
    content: `<p>网红圈近日发生大地震。据多位可靠消息人士确认，某头部短视频平台排名前十的主播在近一周内集体被有关部门约谈，涉及内容包括直播内容违规、税务问题、虚假宣传等多个方面。</p><p>此次约谈发生在平台刚刚完成新一轮融资之后，外界普遍认为这是监管部门对直播行业加强管控的信号。多位被约谈主播的直播间目前已暂停更新，部分主播的账号也出现了限流情况。</p><p>行业分析师指出，经历了野蛮生长期后，直播行业正在进入规范化的新阶段，未来对主播的监管只会越来越严格。</p>`,
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '行业快讯',
    publishDate: '2026-06-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20exterior%20with%20reflective%20glass%20windows%2C%20formal%20meeting%20room%20silhouette%20visible%20through%20windows%2C%20government%20building%20atmosphere%2C%20serious%20and%20professional%20mood%2C%20dramatic%20sky%20with%20clouds%2C%20editorial%20photography%20style&width=800&height=500&seq=article-yuetan-11&orientation=landscape',
    imageAlt: '网红圈大地震平台TOP10主播被约谈',
    tags: ['网红', '约谈', '监管', '直播行业'],
    views: 387200,
    comments: 9876,
    isHot: true,
    isTrending: true,
  },
  {
    id: '12',
    title: '吃瓜闲聊：那些年我们一起追过的塌房网红大盘点',
    slug: 'naxienian-tafang-wanghong-dapandian',
    excerpt: '从2020年到2026年，网红圈塌房事件层出不穷。让我们一起回顾那些曾经红极一时又轰然倒塌的网红们...',
    content: `<p>从2020年到2026年，网红圈经历了无数次"塌房"事件。有的因为偷税漏税，有的因为人设崩塌，还有的因为言行不当。今天，让我们一起回顾那些曾经红极一时又轰然倒塌的网红们。</p><p>2022年的"某账号直播翻车事件"堪称年度最大塌房，一夜之间掉粉百万；2023年的"某头部主播税务风波"更是震惊全行业；2024年的"某情侣网红假恋爱曝光"让无数CP粉心碎一地。</p><p>这些塌房事件不仅让我们看到了网红经济的脆弱性，也提醒着每一个从业者：没有真实的内容和诚信的态度，再大的流量也只是空中楼阁。</p>`,
    category: '八卦杂谈',
    categorySlug: 'bagua-zatan',
    author: '回忆杀小编',
    publishDate: '2026-06-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collage%20style%20photography%20with%20scattered%20polaroid%20photos%20on%20a%20warm%20wooden%20surface%2C%20nostalgic%20retro%20atmosphere%2C%20memories%20and%20reflection%20theme%2C%20soft%20natural%20lighting%20from%20window%2C%20thoughtful%20and%20melancholic%20mood%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=article-pandian-12&orientation=landscape',
    imageAlt: '塌房网红大盘点回顾',
    tags: ['塌房', '网红', '盘点', '回忆'],
    views: 234500,
    comments: 5678,
    isHot: false,
    isTrending: false,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find(a => a.id === id);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter(a => a.categorySlug === categorySlug);
}

export function getHotArticles(): Article[] {
  return articles.filter(a => a.isHot);
}

export function getTrendingArticles(): Article[] {
  return articles.filter(a => a.isTrending);
}

export function getLatestArticles(limit: number = 8): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return articles
    .filter(a => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, limit);
}